'use strict';

/*@ngInject*/
module.exports = function () {
    return {
        scope: {
            objectId: '@'
        },
        bindToController: true,
        controllerAs: 'vm',
        /*@ngInject*/
        controller: function controller(publicObjectsService) {
            var vm = this;

            vm.title = 'Objekti andmete sisestamine';

            vm.objectForm = {};
            vm.showErrors = false;

            vm.name = {};
            vm.description = {};
            vm.imageFilesModal = {};
            vm.features = {};
            vm.accessibility = [];
            vm.accessibilityDuplicatedError = false;
            vm.classifiers = [];
            vm.updateObjectDataError = false;
            vm.updateObjectDataErrorMessage = '';
            vm.updateObjectDataSuccess = false;
            vm.updateObjectDataSuccessMessage = '';

            vm.$onInit = function () {
                publicObjectsService.getForPublicEditByObjectId(vm.objectId, null).then(function (response) {
                    vm.object = response.data;
                    vm.object.webEntry = {};
                    vm.object.type = publicObjectsService.TYPE_OBJECT;
                });
                publicObjectsService.getObjectClassifiers().then(function (response) {
                    vm.classifiers = response.data;
                });
            };

            vm.save = function () {
                vm.updateObjectDataError = false;
                vm.updateObjectDataSuccess = false;

                vm.showErrors = true;
                if (vm.objectForm.$invalid || vm.accessibilityDuplicatedError) {
                    return false;
                }

                vm.object.version.description = [];
                for (var language in vm.description) {
                    var description = vm.description[language];
                    description.language = language;
                    vm.object.version.description.push(description);
                }

                if (vm.object.version.image_files) {
                    for (var i = 0; i < vm.object.version.image_files.length; i++) {
                        vm.object.version.image_files[i].order = i;
                    }
                }

                publicObjectsService.saveObject(vm.object).then(function (response) {
                    if (typeof response.data === 'string') {
                        vm.updateObjectDataError = true;
                        vm.updateObjectDataErrorMessage = 'Salvestamine ebaõnnestus';
                    } else {
                        vm.updateObjectDataSuccess = true;
                        vm.updateObjectDataSuccessMessage = 'Salvestamine õnnestus';
                    }
                });
            };
        },

        template: require('./object-edit.html')
    };
};


/** WEBPACK FOOTER **
 ** ./app/shared/directives/objects/edit/object-edit.directive.js
 **/